import { TEMPLATES } from "./constants";
import { getPlatformForBot } from "../components/Chatbot/ChatbotUtil";
import ChatBotMeta from "../utils/singletonChatBotMeta";

const getParentTopicData = (
  uri = "",
  allPagesData = {}
) => {
  let parentUri = allPagesData[uri]?.parentUri;
  if (parentUri === uri || uri === "" || !parentUri) {
    return { activeChildUri: "", childPages: [] };
  }

  if (
    allPagesData[parentUri]?.templateName ===
    TEMPLATES.TOPIC
  ) {
    const { "child-pages": childPages = [] } =
      allPagesData[parentUri] || {};

    return {
      activeChildUri: uri,
      childPages: childPages,
    };
  }
  return getParentTopicData(parentUri, allPagesData);
};

export const lastItem = arr => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr[arr.length - 1];
  }
  return undefined;
};
export function uuid() {
  return window?.crypto?.randomUUID?.() || uuidFallback();
}
function uuidFallback() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0;
      // eslint-disable-next-line
      const v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}
export default getParentTopicData;

const getValueForQueryParam = function (queryParam) {
  let value = null;
  if (queryParam) {
    if (typeof URLSearchParams === "undefined") {
      queryParam = queryParam
        .replace(/[\[]/, "\\[")
        .replace(/[\]]/, "\\]");
      const regex = new RegExp(
        "[\\?&]" + queryParam + "=([^&#]*)"
      );
      const results = regex.exec(
        window.location.search || window.location.hash
      );
      value =
        results === null
          ? ""
          : decodeURIComponent(
              results[1].replace(/\+/g, " ")
            );
    } else {
      value = new URLSearchParams(
        window.location.search
      ).get(queryParam);
    }
  }
  return value;
};

export const getQueryParams = ({
  faqTitle = "",
  src,
} = {}) => {
  if (!window.token) {
    return;
  }
  const clonedToken = JSON.parse(
    JSON.stringify(window.token)
  );
  const email = clonedToken.userId + "@iris.phonepe.com";

  return {
    src: src || getValueForQueryParam("src") || "help",
    ...(faqTitle && {
      faqTitle,
    }),
    xtrnlTcktId:
      getValueForQueryParam("txnId") ||
      getValueForQueryParam("conversationId") ||
      uuid(),
    data: getValueForQueryParam("data"),
    txnState: getValueForQueryParam("txnState"),
    errorCode: getValueForQueryParam("errorCode"),
    email: email,
    "cstmr::eml": email,
    "cstmr::nm": clonedToken.name,
    platform:
      getValueForQueryParam("platform") ||
      getPlatformForBot(),
  };
};

export const getQueryString = queryObj => {
  if (typeof URLSearchParams === "undefined") {
    return (
      "?" +
      Object.keys(queryObj)
        .map(key => {
          return `${key}=${encodeURIComponent(
            queryObj[key]
          )}`;
        })
        .join("&")
    );
  } else {
    return "?" + new URLSearchParams(queryObj).toString();
  }
};
